import DebugJson from './DebugJson'
import DebugSection from './DebugSection'

export default function DebugRow({
  label,
  value,
  initialOpen = true,
  children,
}: {
  label: string
  value: unknown
  initialOpen?: boolean
  children?: React.ReactNode
}) {
  return (
    <DebugSection title={label}>
      <DebugJson value={value} initialOpen={initialOpen} />
      {children}
    </DebugSection>
  )
}
